import { createApp } from 'vue'
import App from './App.vue'
import './index.css'
import '@fortawesome/fontawesome-free/css/all.min.css'

createApp(App).mount('#app')
